




































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { AppConstants as _app } from "@/shared/app.constants";
import { http as _http } from "@/shared/https";
import { Utilities as utils } from "@/shared/utilities";
import FilterComponent from './Filter.vue';
import GrantCardViewComponent from './GrantCardView.vue';
import GrantGridViewComponent from './GrantGridView.vue';
import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";
import { Locales } from "@/i18n/locales";

@Component({
  components: {
    GrantCardViewComponent,
    GrantGridViewComponent,
    FilterComponent
  }
})
export default class GrantDashboardComponent extends Vue {
  isTabView: boolean = false;
  collapsed = false;
  grants: Array<any> = [];
  items: Array<any> = [];
   defaultLanguage: any = [];  
  filterKey: any;
  tabs = [
    { component: "GrantCardViewComponent", text: "Grid View", icon: "mdi-format-list-bulleted-square" },
    { component: "GrantGridViewComponent", text: "Card View", icon: "mdi-view-grid" }
  ];
  currentTab = this.tabs[0];

  openStatus = [ _app.grantStatus.monitor, _app.grantStatus.closeInProgress, _app.grantStatus.close, _app.grantStatus.suspended, _app.grantStatus.terminated ];
  actions = _app.actions;
  subjects = _app.subjects;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  mounted() {
    this.$services.grant.getFilters().then((data: any) => {
        if (data) {
            this.items = data.Result;
        }
    });
  }

  collapseFilter() {
    this.collapsed = !this.collapsed;
  }

  /** Edit Proposal */
  editGrant(grantId, appId) {
    this.$router.push({
      name: "grantSummary",
      params: { grantId: grantId, appId: appId }
    });
  }

  /** check button access rights */
  accessRights(card, btn) {
    switch (btn) {
      case 'edit': {
        //@ts-ignore
        if(this.$can(this.actions.read, this.subjects.grant) || this.openStatus.includes(card.WorkFlowStatusId))
          return true;
      }
      case 'migrationImport': {
        //@ts-ignore
        if(this.$can(this.actions.create, this.subjects.migrationImport))
          return true;
      }
    }
  }

  get currentTabComponent() {
    return this.currentTab.component;
  }

  switchLayout(isTabView) {
    this.isTabView = !isTabView;

    if (this.isTabView) {
      this.currentTab = this.tabs[1];
    } else {
      this.currentTab = this.tabs[0];
    }
  }

  removeItem(data) {}

  listProposal(e?: any) {
    return this.$services.grant.getGrantsList(e).then((resp: any) => {
      return resp;
    });
  }

  callFilter(e) {
    let filteredData = '';
    const self = this;
    self.filterKey = e;
    self.listProposal(self.filterKey ?? '').then((resp: any) => {
      if(resp.Items && resp.Items.length > -1) {
        self.grants = resp.Items.map(x =>  { 
          x.TotalProjectBudget = x.TotalProjectBudget ? utils.formatCurrency(x.TotalProjectBudget, x.BudgetCurrency, this.defaultLocale ) : null; 
          x.RequestedAmount = x.RequestedAmount ? utils.formatCurrency(x.RequestedAmount, x.BudgetCurrency, this.defaultLocale ) : null; 
          return x;
        });
      }
      if(resp.Filters != null){
        filteredData = JSON.stringify(resp.Filters);
      }      
      let initialFilter = JSON.stringify(self.items);
      if(filteredData && filteredData !== initialFilter){
        self.items = resp.Filters;
      }
    });
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(changedRoute: any) {
    if (changedRoute && changedRoute.name === 'Grants') {
      const self = this;
      self.listProposal(self.filterKey ?? '').then((items: any) => {
        if(items && items.length > -1) {
          self.grants = items.map(x =>  {
            x.TotalProjectBudget = x.TotalProjectBudget ? utils.formatCurrency(x.TotalProjectBudget, x.BudgetCurrency, this.defaultLocale ) : null; 
            x.RequestedAmount = x.RequestedAmount ? utils.formatCurrency(x.RequestedAmount, x.BudgetCurrency, this.defaultLocale ) : null; 
            return x;
          });
        }
      });
    }
  }

  gotoMigrationList() {
    this.$router.push({
      name: "Migrations",
    });
  }
}
